import { MedicalSpecialityEnum } from '@app/icare/entities/clinic/schema/Clinic'
import { entityRegistry } from '@app/icare/entities/registry'
import { Trans } from '@lingui/react/macro'
import { createQueryStore, QueryBaseSchema } from '@pkg/api/query'
import { EntityIndexPage } from '@pkg/ui/layout/EntityIndexPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/kliniken/')({
  component: RouteComponent,
})

const queryStore = createQueryStore({
  schema: entityRegistry.clinic.search.filterSchema ?? QueryBaseSchema,
})

function RouteComponent() {
  return (
    <EntityIndexPage
      entityName="clinic"
      queryStore={queryStore}
      filter={[
        {
          name: 'speciality',
          mode: 'multiple',
          label: <Trans>Art der Klinik</Trans>,
          options: MedicalSpecialityEnum.$.options,
        },
      ]}
    />
  )
}
